export enum LobRoleNameEnum {
    HOST = 1,
    ADMIN,
    VENDOR,
}